import { useContext, useEffect, useState } from 'react';
import { BaseConfirmModal } from '../../../../common/components/modals';
import SimpleBar from 'simplebar-react';
import Flatpickr from 'react-flatpickr';
import { getMonths, handlerFormatDate } from '../../../../utils';
import { AppContext } from '../../../../common';
import { RequestsManagementsAPI } from '../../../../services/external/APIs/requests-managements/RequestsManagements';
import { SchedulingsChangeRequestsHistory } from '../../../../models/requests-management/historyRequests';
import { RequestStatusSelector } from '../../../../common/components/selectors/requestStatus/RequestStatusSelector';
import {
    REQUEST_STATUS,
    RequestStatusEnum,
} from '../../../../constants/requestSatus';

interface HistoryModalProps {
    isOpen: boolean;
    date: Date;
    onClose: (newState: boolean) => void;
}

export const HistoryModal = ({ isOpen, onClose, date }: HistoryModalProps) => {
    const { langResources, lang } = useContext(AppContext);

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<SchedulingsChangeRequestsHistory[]>([]);
    const [startDate, setStartDate] = useState(
        new Date(date.getFullYear(), date.getMonth(), 1).toISOString().slice(0, 10)
    );
    const [status, setStatus] = useState<number | null>(null);
    const [endDate, setEndDate] = useState(
        new Date(date.getFullYear(), date.getMonth() + 1, 0)
            .toISOString()
            .slice(0, 10)
    );

    const handlerClose = () => {
        onClose(false);
    };
    const hanlderSubmit = () => {
        onClose(false);
    };

    const handlerChangeDate = (dates: Date[]) => {
        if (!dates || dates.length < 2) {
            return;
        }
        
        let startDate = handlerFormatDate(dates[0]);
        let endDate = handlerFormatDate(dates[1]);

        if (startDate) setStartDate(startDate);
        if (endDate) setEndDate(endDate);
    };

    useEffect(() => {
        if (startDate !== '' && endDate !== '') {
            consultHistory();
        }
    }, []);

    const consultHistory = () => {
        setIsLoading(true);

        RequestsManagementsAPI.getHistoryByEmployee({
            endDate: endDate,
            startDate: startDate,
            status: status,
        })
            .then((response) => {
                setData(response);
            })
            .finally(() => setIsLoading(false));
    };

    const handlerStatusChange = (name: string, value: string | number) => {
        setStatus(Number(value));
    };

    return (
        <BaseConfirmModal
            isOpen={isOpen}
            modalTitle={'Solicitudes Pendientes'}
            onClose={handlerClose}
            onSubmit={hanlderSubmit}
            disableSubmit={false}
            isShowControls={false}
            isLoading={isLoading}
        >
            <div className='modal-body text-black p-0 m-0'>
                <div className='d-flex align-items-center gap-3 justify-content-between'>
                    <div className='d-flex align-items-center gap-3 '>
                        <RequestStatusSelector
                            name='request-status-selector'
                            onChange={handlerStatusChange}
                            options={REQUEST_STATUS}
                            value={status}
                            required={false}
                        />

                        <div className=''>
                            <label key={`label-`} className='form-label '>
                                Fechas *
                            </label>
                            <div className='date__picker'>
                                <Flatpickr
                                    lang='es'
                                    title={startDate + ' to ' + endDate}
                                    id='picker-date'
                                    className='form-control picker text-black select__control'
                                    options={{
                                        mode: 'range',
                                        dateFormat: 'Y-m-d',
                                        locale: {
                                            months: getMonths(lang),
                                        },
                                    }}
                                    onChange={(date) => {
                                        handlerChangeDate(date);
                                    }}
                                    value={startDate + ' to ' + endDate}
                                    placeholder='YYYY-MM-DD'
                                />
                                <label htmlFor='picker-date'>
                                    <i className='mdi mdi-calendar-blank fs-4 text-muted'></i>
                                </label>
                            </div>
                        </div>
                    </div>
                    <button
                        type='button'
                        className='btn btn-primary'
                        onClick={consultHistory}
                        disabled={isLoading}
                    >
                        Consultar
                    </button>
                </div>

                <div>
                    <SimpleBar
                        data-simplebar-direction='rtl'
                        style={{
                            maxHeight: 'calc(100vh - 250px)',
                            height: 'calc(100vh - 250px)',
                        }}
                        className='py-3 mt-2'
                    >
                        <div className='vstack gap-2'>
                            {data.length === 0 ? (
                                <p>No hay solicitudes</p>
                            ) : (
                                data.map((e, i) => (
                                    <div
                                        key={i}
                                        className='border rounded border-dashed p-2'
                                    >
                                        <div className='d-flex align-items-center'>
                                            <div className='flex-grow-1 overflow-hidden'>
                                                <h5 className='fs-13 mb-1'>
                                                    {e.newSchedulingName &&
                                                        !e.previousSchedulingName &&
                                                        'Solicito ' +
                                                            e.newSchedulingName}

                                                    {e.previousSchedulingName &&
                                                        e.newSchedulingName &&
                                                        'Cambio ' +
                                                            e.previousSchedulingName +
                                                            ' Por ' +
                                                            e.newSchedulingName}
                                                </h5>
                                                <div className='text-muted'>
                                                    {'' +
                                                        new Date(e.date)
                                                            .toISOString()
                                                            .slice(0, 10)}
                                                </div>
                                            </div>

                                            <div className='flex-shrink-0 ms-2 d-flex gap-2'>
                                                <div className='text-end'>
                                                    <h5>
                                                        {
                                                            REQUEST_STATUS.find(
                                                                (i) =>
                                                                    i.value ==
                                                                    e.status
                                                            )?.label
                                                        }
                                                    </h5>
                                                    <div className='text-muted'>
                                                        {e.authorizerName}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </SimpleBar>
                </div>
            </div>
        </BaseConfirmModal>
    );
};
